import React from "react";

import { Disclosure } from "@headlessui/react";
import { IAccordionData } from "types";

const AccordionItem: React.FC<IAccordionData> = ({ title, content }) => (
  <Disclosure>
    {({ open }) => (
      <>
        <Disclosure.Button className="accordion-item mb-3 w-full border-b">
          <div className="accordion-title flex cursor-pointer justify-between">
            <div className="mb-3 text-left text-lg font-medium text-gray-700">
              {title}
            </div>
            <div> {open ? "-" : "+"}</div>
          </div>
        </Disclosure.Button>
        <Disclosure.Panel className="accordion-content mb-4 text-neutral-500">
          {content}
        </Disclosure.Panel>
      </>
    )}
  </Disclosure>
);

const Accordian: React.FC<any> = ({ accordionData }) => (
  <ul className="accordion md:px-28">
    {Array.isArray(accordionData) &&
      accordionData.map((data: any, index: any) => (
        <AccordionItem key={index} {...data} />
      ))}
  </ul>
);

export default Accordian;
